import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'pa-first-tab',
  templateUrl: './first-tab.component.html',
  styleUrls: ['./first-tab.component.scss']
})
export class FirstTabComponent implements OnInit {

  @Input() card: any;
  @Output() indexChange = new EventEmitter();
  @Output() transferLimit = new EventEmitter();
  price: any;

  constructor() {
  }

  ngOnInit(): void {
  }

  allTransferClick() {
    return true;
  }

  continue() {
    let pageIndex = 0;
    if (this.price) {
      pageIndex = 1;
      this.indexChange.emit(pageIndex);
      this.transferLimit.emit(this.price);
    } else {
      pageIndex = 0;
      this.indexChange.emit(pageIndex);
    }
  }
}
